module.exports = __webpack_public_path__ + "static/jitsimeet and firewall-a7e7179a254f7eeba161648cb71fd2f8.png";